export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $videosOnSite = document.querySelectorAll('video.ce__isnack-videoonsite-video');

        if (!$videosOnSite.length) {
            return;
        }

        function addSourceToVideo(element, src) {
            const source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            element.appendChild(source);
        }

        function seteVideoOnInit(element) {
            const windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
            if (windowWidth > element.dataset.breakpointVid) {
                addSourceToVideo(element, element.dataset.desktopVid);
            } else {
                addSourceToVideo(element, element.dataset.mobileVid);
            }
        }

        $videosOnSite.forEach((videoOnSite) => {
            seteVideoOnInit(videoOnSite);
        });
    });
}
